import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront';
import { KnBrMyQuoteHeaderComponent } from './kn-br-my-quote-header.component';

@NgModule({
  declarations: [KnBrMyQuoteHeaderComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    NgSelectModule,
    NgbModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrStep2CustomerQuoteHeaderComponent: {
          component: () => import('./kn-br-my-quote-header.component').then((c) => c.KnBrMyQuoteHeaderComponent),
        },
      },
    } as CmsConfig),
    SpinnerModule,
    MatSlideToggleModule,
  ],
  exports: [KnBrMyQuoteHeaderComponent],
})
export class KnBrMyQuoteHeaderModule {}
